import { Table, TableCell, tableCellClasses } from '@mui/material';
import styled from 'styled-components';
import { color } from '../../styles';

export const CELL_WIDTH = "140px ";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: '#0D0C0C',
        fontSize: '13px',
        fontWeight: '700',
        lineHeight: '18px',
        whiteSpace: 'pre-line',
        padding: '4px 8px 4px 8px',
        minWidth: CELL_WIDTH,
        fontFamily: 'Noto Sans',
        backgroundColor: color.secondary.LIGHT_GREY,
    },
    [`&.${tableCellClasses.body}`]: {
        color: '#0D0C0C',
        fontSize: '13px',
        fontWeight: '400',
        lineHeight: '28px',
        wordWrap: 'break-word',
        whiteSpace: 'normal',
        padding: '2px 8px 2px 8px',
        minWidth: CELL_WIDTH,
        fontFamily: 'Noto Sans',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
}));

export const TableContainer = styled.div`
    width: 100%;
    overflow: auto;
    display: block;
    margin-bottom: 0;
    border: 1px solid ${color.secondary.GREY_4};
    border-radius: 5px;
    max-height: calc(100vh - 280px);
    max-width: 100%;
    box-sizing: border-box;
`;

export const StyledTable = styled(Table)`
    width: 100%;
    & .MuiTableCell-root {
        border-bottom: 1px solid ${color.secondary.GREY_4};
    }

    /* Avoid double-thick bottom edge (container border + last row border) */
    & .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root {
        border-bottom: 0;
    }

    & .MuiTableCell-head {
        border-bottom: 1px solid ${color.secondary.GREY_4};
        color: #111;
        font-weight: 700;
    }

    & .MuiTableBody-root .MuiTableRow-root:nth-of-type(even) {
        background-color: ${color.emphasis.NEUTRAL_N5};
    }
`;

export const TableCellHeaderContent = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const CategoryContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 4px 0;
    max-width: 120px;
    align-items: center;
`;